export type RetailMediaPayload = {
  zone: string;
  visitorId: string;
  consent?: {
    gdpr: boolean;
  } | null;
  sponsoredProductsCount?: number;
  searchTerm?: string;
  categories?: string[];
  sessionId?: string;
  debug: boolean;
  userAgent: string;
  dsaBrand?: DsaBrand;
  brandNames?: string[];
};

export type RetailMediaResponse = {
  sponsoredProducts: Array<RetailMediaProduct>;
};

export type RetailMediaProduct = {
  adId: number;
  brand: string;
  title: string;
  price: number;
  currency: string;
  clickUrl: string;
  imageUrl: string;
  advertiser: string;
  productUrl: string;
  impressionUrl: string;
  dsaUrl: string;
};

export type RetailMediaTrackingPayload = {
  trackingUrl: string;
  sessionId?: string;
};

export type DsaBrand = (typeof DsaBrand.values)[number];

export namespace DsaBrand {
  export const values = ['dba', 'blocket', 'tori', 'finn', 'bilbasen'] as const;

  export function is(value: string | null | undefined): value is DsaBrand {
    if (!value) return false;
    return values.includes(value as DsaBrand);
  }
}
